module.exports = __webpack_public_path__ + "static/media/home-tile-2.b9bb1cec.png";